export interface Item {
  id: string;
  description: string;
  qty: number;
  price: number;
}

export interface Invoice {
  id: string;
  customer: string;
  date: string; // ISO date
  items: Item[];
  notes?: string;
}

export function invoiceTotal(inv: Invoice): number {
  return inv.items.reduce((s, it) => s + it.qty * it.price, 0);
}

// Note: no default export; interfaces are types only
